module.exports = "/static/assets/82b7f01c0e0f7966c9a2bb4c1bcc6298.png";